module.exports = __webpack_public_path__ + "img/undraw_Invite_re_rrcp.b67b3b1b.svg";